import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Boxes, FileCheck2, ClipboardList, History, AlertTriangle, ShieldAlert } from "lucide-react";

export default function Dashboard() {
  const [m, setM] = useState(null);
  useEffect(() => { api.get("/admin/dashboard").then((r) => setM(r.data)); }, []);
  const Stat = ({ icon: Icon, label, value, accent, to }) => (
    <Link to={to || "#"} className="border border-[#D1D5DB] p-5 bg-white hover:bg-[#F7F7F8] transition-colors block">
      <Icon className="h-5 w-5" strokeWidth={1.6} style={{ color: accent || "#003366" }} />
      <div className="font-mono text-[10.5px] tracking-[0.18em] uppercase text-[#5E636E] mt-3">{label}</div>
      <div className="font-mono text-3xl font-semibold mt-1" style={{ color: accent || "#111216" }}>{value ?? "—"}</div>
    </Link>
  );
  return (
    <div className="max-w-screen-2xl mx-auto px-6 py-10">
      <div className="label-eyebrow">Compliance Console</div>
      <h1 className="text-3xl font-bold tracking-tight mt-1">Operations Overview</h1>
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 mt-8" data-testid="admin-stats">
        <Stat icon={Boxes} label="Products" value={m?.products} to="/admin/products" />
        <Stat icon={ClipboardList} label="Orders pending review" value={m?.pending_review} accent="#9A6B00" to="/admin/orders" />
        <Stat icon={FileCheck2} label="Active COAs" value={m?.active_coas} accent="#0B6623" to="/admin/coas" />
        <Stat icon={ShieldAlert} label="Products pending legal review" value={m?.flagged_products} accent="#9A6B00" to="/admin/products" />
        <Stat icon={AlertTriangle} label="High-risk products" value={m?.high_risk_products} accent="#A30414" to="/admin/products" />
        <Stat icon={History} label="Audit log entries" value={m?.audit_entries} to="/admin/audit" />
      </div>
      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="border border-[#D1D5DB] p-5">
          <div className="label-eyebrow">Current Catalog Boundaries</div>
          <ul className="mt-3 text-sm text-[#111216] space-y-2 list-disc list-inside marker:text-[#D0021B]">
            <li>Restricted incretin-class / metabolic weight-loss compounds — <span className="font-mono">prohibited</span></li>
            <li>Bacteriostatic / sterile water for injection — <span className="font-mono">prohibited</span></li>
            <li>Syringes, needles, alcohol swabs, sharps — <span className="font-mono">prohibited</span></li>
            <li>Reconstitution / injection kits — <span className="font-mono">prohibited</span></li>
          </ul>
        </div>
        <div className="border border-[#D1D5DB] p-5">
          <div className="label-eyebrow">Manual Review Triggers</div>
          <ul className="mt-3 text-sm space-y-2 list-disc list-inside marker:text-[#003366]">
            <li>High-risk product · <span className="font-mono">automatic</span></li>
            <li>Large quantity (≥10) · <span className="font-mono">automatic</span></li>
            <li>New account (&lt; 48h) · <span className="font-mono">automatic</span></li>
            <li>Personal email domain · <span className="font-mono">automatic</span></li>
            <li>Residential shipping address · <span className="font-mono">automatic</span></li>
          </ul>
        </div>
      </div>
    </div>
  );
}
